module.exports = __webpack_public_path__ + "static/media/Montserrat-LightItalic.471a0493.ttf";